import { sendDistributions, type Metric } from '@mentimeter/errors/sendMetric';
import type { DevSession } from '../interfaces/DevSession';
import { log } from '../utils/logger';

function devSessionToMetrics(devSession: DevSession): Metric[] {
  const metrics = devSession.hotReloads.map((entry) => ({
    name: 'mmjs.dev.hot_reload.duration' as const,
    value: entry.duration,
    tags: [
      `application:${devSession.application}` as const,
      `userId:${devSession.userId}` as const,
      `devCommand:${devSession.devCommand}` as const,
    ],
  }));

  return metrics;
}

export function sendSessionToDatadog(session: DevSession, verbose = false) {
  if (!session || !session.hotReloads?.length) return;

  try {
    const datadogCustomMetrics = devSessionToMetrics(session);
    sendDistributions(datadogCustomMetrics);
    if (verbose) {
      log('log', `Sent session to Datadog: ${session.sessionId}`);
    }
  } catch (err) {
    if (verbose) {
      log('error', `Failed to send session to Datadog:`, err);
    }
  }
}
